<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner';
import { Elevation } from '@apparatix/constants/Elevation';

defineProps<{ loading: boolean }>();

const spinnerZIndex = Elevation.mask + 1;
const maskZIndex = Elevation.mask;
</script>
<template>
  <div v-if="loading" class="loading-mask">
    <ProgressSpinner
      style="width: 75px; height: 75px;"
      :stroke-width="3"
      fill="transparent"
      animation-duration="1s"
      :pt="{
        circle: {
          style: {
            stroke: '#000 !important'
          }
        }
      }"
      :style="{zIndex: spinnerZIndex}"
    />
  </div>
</template>
<style scoped>
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: v-bind(maskZIndex);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
}
</style>
